// import { ServInstance } from "../config";
import axios from 'axios';

const servInstance = process.env.REACT_APP_BASE_URL;

axios.defaults.headers.common = {
    Accept: 'application/json',
    ...(localStorage.getItem('token') ? { Authorization: `Bearer ${localStorage.getItem('token')}` } : {}),
};

export const refreshheaderToken = (token) => {
    if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        axios.defaults.headers.common['Authorization'] = null;
    }
};

const api = {
    get: (URL, queryParams, type = {}) => axios.get(servInstance + URL, queryParams, type).then((res) => res.data),
    post: (URL, reqData = {}) => axios.post(servInstance + URL, reqData).then((res) => res.data),

    put: (URL, reqData = {}) => axios.put(servInstance + URL, reqData).then((res) => res.data),

    delete: (URL, reqData = {}) => axios.delete(servInstance + URL, reqData).then((res) => res.data),
      patch: (URL, reqData = {}, config = {}) =>
    axios.patch(servInstance + URL, reqData, config).then((res) => res.data),
};
export default api;
